import {PaymentElement as IntentCardElement} from '@stripe/react-stripe-js';
import {PaymentElement as CheckoutCardElement} from '@stripe/react-stripe-js/checkout';
import {APP_BASE} from './router';
import './checkout-wallets.css';

const cardOptions={layout:'tabs' as const,wallets:{applePay:'never' as const,googlePay:'never' as const}};

export function CheckoutCardFields({checkout=false}:{checkout?:boolean}){
  const Element=checkout?CheckoutCardElement:IntentCardElement;
  return <section className="checkout-other-methods" aria-label="Credit or debit card">
    <div className="checkout-card-heading"><h2>Or pay with credit / debit card</h2>
      <div className="checkout-card-marks"><img src={`${APP_BASE}/assets/payments/visa.svg`} alt="Visa"/><img src={`${APP_BASE}/assets/payments/mastercard.svg`} alt="Mastercard"/></div>
    </div>
    <Element options={cardOptions}/>
  </section>;
}
